import React from 'react'
import { avatarColorSeed, avatarColorSlot, avatarGraphemes, avatarInitials } from './avatarInitials'

interface InitialsAvatarUser {
    id?: string | number | null
    name?: string | null
}

interface InitialsAvatarProps {
    user: InitialsAvatarUser
    className?: string
    onClick?: () => void
}

// Generated fallback avatar: the user's initials (up to two characters) on a
// color picked deterministically from the user id. Colors are
// --color-avatar-<n>-* theme variables, so light/dark mode switching needs no
// JS. Renders nothing when the user has no name — callers decide their own
// empty placeholder.
export default function InitialsAvatar({ user, className, onClick }: InitialsAvatarProps) {
    const initials = avatarInitials(user?.name)
    if (!initials) return null

    const slot = avatarColorSlot(avatarColorSeed(user))
    const fontSize = avatarGraphemes(initials).length > 1 ? 15.5 : 19

    return (
        <svg
            viewBox="0 0 40 40"
            // Attribute (not inline-style) sizing so a caller's className with
            // explicit width/height still wins.
            width="100%"
            height="100%"
            className={className}
            onClick={onClick}
            role="img"
            aria-label={`${user.name} avatar`}
            style={{ display: 'block' }}
        >
            <circle cx="20" cy="20" r="20" fill={`var(--color-avatar-${slot}-bg)`} />
            <text
                x="20"
                y="20.5"
                textAnchor="middle"
                dominantBaseline="central"
                fontSize={fontSize}
                fontWeight="600"
                fill={`var(--color-avatar-${slot}-text)`}
            >
                {initials}
            </text>
        </svg>
    )
}
